import React from "react";
import i18n from "../../../i18n/i18n";
import ActionForm from "../actionForm/actionForm";
import "./addAction.scss";

class AddAction extends React.Component {
    public render(): JSX.Element {
        return (
            <div className="add-action content">
                <div className="header">
                    {i18n.t("timetable.actions.addAction.header")}
                </div>
                <div>
                    <ActionForm isUpdate={false}/>
                </div>
            </div>
        );
    }
}

export default AddAction;
